import React from 'react';
import { PropTypes } from 'prop-types';
import { Button } from '@ipc/ipc-components';

import { AppContentInner, AppContentTitle } from '../../styles';
import ReceptaclesListTable from '../../components/custom/ReceptaclesListTable';
import { ButtonsWrapper } from './styles';
import { getReceptacleListTitle } from './constants';

function RecordsList({ history, location: { search }, match: { params: { filter = '' } } }) {
  const urlParams = new URLSearchParams(search);
  const recordId = urlParams.get('recordId');

  return (
    <AppContentInner>
      <AppContentTitle>{getReceptacleListTitle(filter, 'List')}</AppContentTitle>
      <ReceptaclesListTable recordId={recordId} filter={filter} search={search} />
      <ButtonsWrapper marginTop="0px">
        <Button className="CancelButton" onClick={history.goBack}>Back</Button>
      </ButtonsWrapper>
    </AppContentInner>
  );
}

RecordsList.propTypes = {
  location: PropTypes.shape(),
  match: PropTypes.shape(),
  history: PropTypes.shape(),
};

export default RecordsList;
